export default __webpack_public_path__ + "static/media/lasagne.0f2ab1a9.webp";